export default __webpack_public_path__ + "static/media/13.eb49e195.jpg";